var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    stroke: "none",
    xmlns: "https://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.803,12.673l3.147,3.147c0.24,0.24 0.63,0.24 0.87,0c0.24,-0.24 0.24,-0.63 0,-0.87l-3.147,-3.147c1.085,-1.29 1.686,-2.926 1.686,-4.623c-0,-1.905 -0.756,-3.731 -2.103,-5.077c-1.346,-1.347 -3.172,-2.103 -5.076,-2.103c-1.905,0 -3.731,0.756 -5.077,2.103c-1.347,1.346 -2.103,3.172 -2.103,5.077c0,1.904 0.756,3.73 2.103,5.076c1.346,1.347 3.172,2.103 5.077,2.103c1.697,-0 3.333,-0.601 4.623,-1.686Zm-0.35,-1.355c1.074,-1.108 1.675,-2.592 1.675,-4.138c0,-1.578 -0.626,-3.091 -1.742,-4.207c-1.116,-1.115 -2.629,-1.742 -4.206,-1.742c-1.578,0 -3.091,0.627 -4.207,1.742c-1.115,1.116 -1.742,2.629 -1.742,4.207c0,1.577 0.627,3.09 1.742,4.206c1.116,1.116 2.629,1.742 4.207,1.742c1.546,0 3.03,-0.601 4.138,-1.675c0.019,-0.026 0.039,-0.05 0.062,-0.073c0.023,-0.023 0.047,-0.043 0.073,-0.062Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f557ab812a332388fa2ee7fb42fa4c4f.svg";
export { ForwardRef as ReactComponent };